import { ReactElement, useRef, useEffect } from 'react';

import { DoubleScrollHorizontalProps } from './types';
import { useColumnsToggleContext } from './ColumnToggleContext';
import {
  DoubleScrollHorizontalTopScroll,
  DoubleScrollHorizontalTopScrollInner,
} from './styles';

const DoubleScrollHorizontal = ({
  data,
  loading,
  pagination,
  children,
}: DoubleScrollHorizontalProps): ReactElement => {
  const topScrollRef = useRef<HTMLDivElement>(null);
  const topInnerRef = useRef<HTMLDivElement>(null);
  const containerTableRef = useRef<HTMLDivElement>(null);

  const { toggleModel, columns } = useColumnsToggleContext();

  useEffect(() => {
    const topScrollEl = topScrollRef.current;
    const topInnerEl = topInnerRef.current;

    if (!topScrollEl || !topInnerEl) return;

    const tableWrapperEl = containerTableRef.current?.querySelector(
      '.wrapper-data-table-content-id',
    );

    if (!tableWrapperEl) return;

    const syncWidth = () => {
      const hasOverflow =
        tableWrapperEl.scrollWidth > tableWrapperEl.clientWidth;

      topInnerEl.style.width = `${tableWrapperEl.scrollWidth}px`;
      topInnerEl.style.display = hasOverflow ? 'block' : 'none';
      topScrollEl.style.display = hasOverflow ? 'block' : 'none';
    };

    const resizeObserver = new ResizeObserver(syncWidth);
    resizeObserver.observe(tableWrapperEl);

    const onTopScroll = () => {
      tableWrapperEl.scrollLeft = topScrollEl.scrollLeft;
    };

    const onWrapperScroll = () => {
      topScrollEl.scrollLeft = tableWrapperEl.scrollLeft;
    };

    topScrollEl.addEventListener('scroll', onTopScroll);
    tableWrapperEl.addEventListener('scroll', onWrapperScroll);

    syncWidth();

    return () => {
      resizeObserver.disconnect();
      topScrollEl.removeEventListener('scroll', onTopScroll);
      tableWrapperEl.removeEventListener('scroll', onWrapperScroll);
    };
  }, [data, columns, toggleModel, loading]);

  useEffect(() => {
    const topScrollEl = topScrollRef.current;

    if (!topScrollEl) return;

    topScrollEl.scrollLeft = 0;
  }, [toggleModel, pagination]);

  return (
    <>
      <DoubleScrollHorizontalTopScroll ref={topScrollRef}>
        <DoubleScrollHorizontalTopScrollInner ref={topInnerRef} />
      </DoubleScrollHorizontalTopScroll>

      <div ref={containerTableRef} style={{ height: '100% ' }}>
        {children}
      </div>
    </>
  );
};

export default DoubleScrollHorizontal;
